import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "navBar" }
const _hoisted_2 = { class: "flex align-center justify-center gap-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "caption transparent" }
const _hoisted_5 = { class: "flex gap justify-end" }
const _hoisted_6 = { class: "flex gap-2" }

import { onMounted } from "vue";
import { l, languages, currentLanguage, loadLanguageSet, Languages } from "@/services/lang-service";
import { loadDeck } from "@/services/spawn-deck-service";


export default /*@__PURE__*/_defineComponent({
  __name: 'Nav',
  setup(__props) {

onMounted(()=>{
	const lang = localStorage.getItem("lang");
	if(lang && languages.some(l => l === lang)){
		currentLanguage.value = lang as Languages;
		loadLanguageSet();
	}
})

const saveSettings = () => {
	localStorage.setItem('lang', currentLanguage.value);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        height: "30",
        src: require('@/assets/img/logo.png')
      }, null, 8, _hoisted_3),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(l).title), 1),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "caption transparent" }, " by. Cerceis@2022 ", -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btnMini",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/')))
        }, _toDisplayString(_unref(l).play), 1),
        _createElementVNode("button", {
          class: "btnMini",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.replace('/deckMaker')))
        }, _toDisplayString(_unref(l).deckMaker), 1),
        _createElementVNode("button", {
          class: "btnMini",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(loadDeck) && _unref(loadDeck)(...args)))
        }, _toDisplayString(_unref(l).load), 1)
      ]),
      _createElementVNode("span", null, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(currentLanguage) ? (currentLanguage).value = $event : null)),
          onChange: _cache[4] || (_cache[4] = ($event: any) => {_unref(loadLanguageSet)(_unref(currentLanguage)); saveSettings();})
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (lang) => {
            return (_openBlock(), _createElementBlock("option", { key: lang }, _toDisplayString(lang), 1))
          }), 128))
        ], 544), [
          [_vModelSelect, _unref(currentLanguage)]
        ])
      ])
    ])
  ]))
}
}

})